export const isElementPartOfOtherElements = (element: HTMLElement, otherElementsIds?: string[]) => {
  const otherElements = otherElementsIds?.map((childrenId) => document.getElementById(childrenId))
  return otherElements?.some((otherElement) => otherElement && otherElement.contains(element))
}
